
import { Injectable } from "@angular/core"
import { environment } from "../../../../environments/environment"
import { AppService } from "src/app/core/services/app.service"
import { DEFAULT_PAGE_SIZE } from "../lib/constants"
import { HttpClient, HttpParams } from "@angular/common/http"
import {
  CustomURLEncoder,
  isNullOrUndefined,
} from "src/app/core/helpers/http-params-extensions"
import { TagType } from "src/app/shared/enum/tagType"

@Injectable()
export class TagService {
  private post_tag_url: string
  private get_tag_url: string
  private get_tag_paginate_administrator_url: string
  private get_tag_id_url: string
  private get_tag_schooId_url: string
  private put_tag_id_url: string
  private get_tagType_url: string
  
  // Endpoint v2
  private get_structured_tag: string
  private get_tags_options_url: string

  private buildUrls(tagsUrl: string) {
    this.post_tag_url = tagsUrl + environment.endpointTag.routes.post_tag
    this.get_tag_url = tagsUrl + environment.endpointTag.routes.get_tag
    this.get_tag_id_url = tagsUrl + environment.endpointTag.routes.get_tag_id
    this.put_tag_id_url = tagsUrl + environment.endpointTag.routes.put_tag_id
    this.get_tagType_url = tagsUrl + environment.endpointTag.routes.get_tagType
    this.get_tag_schooId_url =
      tagsUrl + environment.endpointTag.routes.get_tag_schoolId
    this.get_tag_paginate_administrator_url =
      tagsUrl +
      environment.endpointTag.routes.get_tag_paginate_administrator_url
  }

  private buildUrlsV2(endpointTagUrl: string) {
    this.get_structured_tag     =   endpointTagUrl + environment.endpointTagV2.routes.get_structured_tag
    this.get_tags_options_url   =   endpointTagUrl + environment.endpointTagV2.routes.get_tags_options
  }

  constructor(private httpClient: HttpClient, private appService: AppService) {
    this.buildUrls(environment.endpointTag.url)
    this.buildUrlsV2(environment.endpointTagV2.url)
  }

  postTag(tag: any) {
    return this.httpClient.post(this.post_tag_url, tag)
  }

  getAllTags(ofType?: TagType[]) {
    let params = new HttpParams({ encoder: new CustomURLEncoder() })
    if (ofType && ofType.length > 0) {
      params = params.set("of", ofType.join(","))
    }
    return this.httpClient.get<any>(this.get_tag_url, { params })
  }

  getTypeTags() {
    return this.httpClient.get<any>(this.get_tagType_url)
  }

  getOneTag(id: number) {
    return this.httpClient.get<any>(
      this.get_tag_id_url.replace("{tagId}", id.toString())
    )
  }

  getTagsBySchoolId(schoolId: string) {
    return this.httpClient.get<any>(
      this.get_tag_schooId_url.replace("{schoolId}", schoolId)
    )
  }

  getPaginateTagAdministrator(tag: any) {
    let params = new HttpParams({ encoder: new CustomURLEncoder() })

    if (!isNullOrUndefined(tag.tagKey)) {
      params = params.set("tagKey", String(tag.tagKey))
    }
    if (!isNullOrUndefined(tag.tagAlias)) {
      params = params.set("tagAlias", String(tag.tagAlias))
    }
    if (!isNullOrUndefined(tag.tagTypeCode)) {
      params = params.set("tagTypeCode", String(tag.tagTypeCode))
    }
    if (!isNullOrUndefined(tag.orderByFilter)) {
      params = params.set("orderByFilter", String(tag.orderByFilter))
    }
    if (!isNullOrUndefined(tag.isDesc)) {
      params = params.set("IsDesc", String(tag.isDesc))
    }
    params = params.set(
      "askPage",
      String(!isNullOrUndefined(tag.askPage) ? tag.askPage : 1)
    )
    params = params.set(
      "itensPerPage",
      String(
        !isNullOrUndefined(tag.itensPerPage)
          ? tag.itensPerPage
          : DEFAULT_PAGE_SIZE
      )
    )

    return this.httpClient.get<any>(this.get_tag_paginate_administrator_url, {
      params,
    })
  }

  putTag(tag: any) {
    return this.httpClient.put(
      this.put_tag_id_url.replace("{tagId}", tag.id),
      tag
    )
  }

  // Endpoint V2
  getStructuredTags(isStructured: boolean) {
    let params = new HttpParams({ encoder: new CustomURLEncoder() })
    params = params.set("structured", String(isStructured))

    return this.httpClient.get(this.get_structured_tag, { params })
  }

  getSegmentByGradeId(parentId: string) {
    return this.httpClient.get<any>(
      this.get_tags_options_url.replace("{parentId}", parentId)
    )  
  }
}
